import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import * as React from 'react';
import * as styles from './styles.css';
import { Header2, InlineText1, InlineText2 } from '@cian/ui-kit/typography';
import { EHelpTextPosition } from '../../constants';
import { Col, Row } from '@cian/ui-kit';
import { getFieldSize } from '../../utils';
import { FieldWrapper } from '../FieldWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var QuestionLayout = function QuestionLayout(props) {
  var _question$helpText, _question$subtitle, _question$helpText2, _question$helpText$co;

  var question = props.question,
      error = props.error,
      actions = props.actions,
      fieldMapper = props.fieldMapper,
      above = props.above; // HelpText - DEPRECATED
  // Используется только для поддержки обратной совместимости

  var upperHelpText = ((_question$helpText = question.helpText) === null || _question$helpText === void 0 ? void 0 : _question$helpText.position) === EHelpTextPosition.Above && question.helpText.text;
  var subtitle = (_question$subtitle = question.subtitle) !== null && _question$subtitle !== void 0 ? _question$subtitle : upperHelpText;
  return /*#__PURE__*/_jsxs("div", {
    className: styles['container'],
    "data-testid": "questionLayout",
    children: [/*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx(Header2, {
        children: question.title
      })
    }), subtitle && /*#__PURE__*/_jsx("div", {
      className: styles['subtitle'],
      children: /*#__PURE__*/_jsx(InlineText1, {
        color: "black_100",
        children: subtitle
      })
    }), above && /*#__PURE__*/_jsx("div", {
      className: styles['above'],
      children: above
    }), /*#__PURE__*/_jsx("div", {
      className: styles['answer'],
      children: /*#__PURE__*/_jsx(Row, {
        children: question.fields.map(function (field) {
          var FieldComponent = fieldMapper(field.type);
          return /*#__PURE__*/_jsx(Col, _objectSpread(_objectSpread({}, getFieldSize(field)), {}, {
            children: /*#__PURE__*/_jsx(FieldWrapper, {
              children: /*#__PURE__*/_jsx(FieldComponent, _objectSpread({}, field))
            })
          }), field.name);
        })
      })
    }), actions && /*#__PURE__*/_jsx("div", {
      className: styles['actions'],
      children: actions
    }), error && /*#__PURE__*/_jsx("div", {
      className: styles['error'],
      "data-testid": "error",
      children: /*#__PURE__*/_jsx(InlineText2, {
        color: "error_100",
        children: error
      })
    }), ((_question$helpText2 = question.helpText) === null || _question$helpText2 === void 0 ? void 0 : _question$helpText2.position) === EHelpTextPosition.Below && /*#__PURE__*/_jsx("div", {
      className: styles['footer'],
      "data-testid": "footer",
      children: /*#__PURE__*/_jsx(InlineText2, {
        color: (_question$helpText$co = question.helpText.color) !== null && _question$helpText$co !== void 0 ? _question$helpText$co : 'black_100',
        children: question.helpText.text
      })
    })]
  });
};
QuestionLayout.displayName = 'QuestionLayout';